// document.addEventListener('DOMContentLoaded', function() {
//   document.querySelectorAll('.active-second-layer, .second-layer-link, .third-layer-link').forEach(function(element) {
//     element.addEventListener('click', function(e) {
//       e.preventDefault();
//       var nextElement = this.nextElementSibling;
//       if (nextElement && (nextElement.classList.contains('second-layer-link-list') || nextElement.classList.contains('third-layer-link-list'))) {
//         nextElement.classList.toggle('second-active');
//         nextElement.classList.toggle('third-active');
//       }
//     });
//   });
//   document.querySelectorAll('.back-to-list').forEach(function(element) {
//     element.addEventListener('click', function(e) {
//       e.preventDefault();
//       var parentElement = this.parentElement;
//         parentElement.classList.toggle('second-active');
//         parentElement.classList.toggle('third-active');
//     });
//   });
// });  Ignore This { but not remove }

document.addEventListener('DOMContentLoaded', function() {


  var manu_mobile_slider =  new Swiper('.menu-slides', {
    loop: false,
    slidesPerView: 'auto',
    paginationClickable: true,
    spaceBetween: 40
  });
  
   const swiper_index = document.querySelector('.swiper-container.menu-slides .swiper-slide .slide-link.active');
   if(swiper_index){
    manu_mobile_slider.slideTo(swiper_index.getAttribute('data-loop-index'),1000,false);
   }

  // document.querySelectorAll('.active-second-layer, .active-third-layer, .back-to-list').forEach(function(element) {
  //   element.addEventListener('click', function(e) {
  //     e.preventDefault();

  
  //     var nextElement = this.nextElementSibling;
  //     var parentElement = this.parentElement;
  //     var container = this.closest('.mobile-nav-bar-block');
  //     var swioer_index = this.getAttribute('data-loop-index');

  //     if (swioer_index != null) {
  //       manu_mobile_slider.slideTo(swioer_index, 1000, false);
  //     }

  //     const scrollDiv = this.closest('.second-layer-link-list');
  //     if (scrollDiv != null) {
  //       scrollDiv.scrollTo({ top: 0, behavior: 'smooth' });
  //     }

  //     console.log("nextElement",nextElement)
  //     console.log("parentElement",parentElement)
  
  //     if (nextElement && (nextElement.classList.contains('second-layer-link-list') || nextElement.classList.contains('third-layer-link-list'))) {
        
  //         nextElement.classList.toggle('second-active');
  //         nextElement.classList.toggle('third-active');
  
  //       if (container && nextElement.classList.contains('second-active') || nextElement.classList.contains('third-active')) {
  //         container.style.height = nextElement.scrollHeight + 'px';
  //       } else {
  //         container.style.height = '';
  //       }
  
  //     } else {
  //       parentElement.classList.toggle('second-active');
  //       parentElement.classList.toggle('third-active');
  //     }
  
  //     // Toggle body class based on active submenu
  //     if (document.querySelector('.second-layer-link-list.third-active')) {
  //       document.body.classList.add('mobile-menu-open');
  //     } else {
  //       document.body.classList.remove('mobile-menu-open');
  //     }
  //   });
  // });



  
      let secondLayerStoredHeight = 0;
    document.querySelectorAll('.active-second-layer, .active-third-layer, .back-to-list').forEach(function (element) {
      element.addEventListener('click', function (e) {
        e.preventDefault();
    
        const clicked = this;
        const nextElement = clicked.nextElementSibling;
        const container = clicked.closest('.mobile-nav-bar-block');
        const swiper_index = clicked.getAttribute('data-loop-index');
    
        if (swiper_index != null && typeof manu_mobile_slider !== 'undefined') {
          manu_mobile_slider.slideTo(swiper_index, 1000, false);
        }
    
        const scrollDiv = clicked.closest('.second-layer-link-list');
        if (scrollDiv) {
          scrollDiv.scrollTo({ top: 0, behavior: 'smooth' });
        }
    
        // === Forward Navigation (Second -> Third) ===
        if (clicked.classList.contains('active-third-layer') && nextElement?.classList.contains('third-layer-link-list')) {
          // Store second-layer height before going deeper
          const parentSecondLayer = clicked.closest('.second-layer-link-list');
          if (parentSecondLayer) {
            secondLayerStoredHeight = parentSecondLayer.scrollHeight;
          }
    
          nextElement.classList.add('third-active');
        }
    
        // === Forward Navigation (First -> Second) ===
        if (clicked.classList.contains('active-second-layer') && nextElement?.classList.contains('second-layer-link-list')) {
          nextElement.classList.add('second-active');
        }
    
        // === Back Navigation ===
        if (clicked.classList.contains('back-to-list')) {
          const currentOpen = clicked.closest('.third-layer-link-list.third-active, .second-layer-link-list.second-active');
          if (currentOpen?.classList.contains('third-layer-link-list')) {
            currentOpen.classList.remove('third-active');
    
            if (secondLayerStoredHeight > 0) {
              setTimeout(() => {
                container.style.height = secondLayerStoredHeight + 'px';
              }, 20);
            }
    
          } else if (currentOpen?.classList.contains('second-layer-link-list')) {
            currentOpen.classList.remove('second-active');
            container.style.height = '';
          }
        }
    
        if (nextElement && (nextElement.classList.contains('second-layer-link-list') || nextElement.classList.contains('third-layer-link-list'))) {
          setTimeout(() => {
            container.style.height = nextElement.scrollHeight + 'px';
          }, 20);
        }
    
        // === Body class toggle ===
        if (document.querySelector('.second-layer-link-list.second-active, .third-layer-link-list.third-active')) {
          document.body.classList.add('mobile-menu-open');
        } else {
          document.body.classList.remove('mobile-menu-open');
        }
      });
    });




});

(function() {
 var searchResultsWrapper = document.querySelector('[data-search-resualt]');
  if (searchResultsWrapper) {    
   searchResultsWrapper.style.display = 'none'; 
  }
})();

document.querySelector('input[name="q"]').addEventListener('input', function() {
  var searchInput = this.value;
  var searchResultsWrapper = document.querySelector('[data-search-resualt]'); 
  if (searchInput.trim() === '') {
    searchResultsWrapper.style.display = 'none';
  } else {
    searchResultsWrapper.style.display = 'block';
  }
});

// product-details-pop-view 

$(document).ready(function() {
  new Swiper('.product-image-slider', {
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        type: "progressbar"
      },
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 0
  });

  $('.pop-up-btn').on('click', function() {
    $('.product-details-pop-up-block').css('display', 'none');
    $($(this).attr('data-popup-id')).css('display', 'block');
    $('body').css('overflow', 'hidden');
  });
});